// @ts-nocheck

import React from 'react';
import classNames from 'classnames';

import './styles.scss';

const TexITextInput = (props: ITextIinput) => {
  const {
    modifier,
    type,
    readOnly,
    label,
    hideLabel,
    name,
    value,
    placeholder,
    error,
    approved,
    onChange,
    min,
    max,
    maxLength,
    numberOnly,
    telOnly,
    className,
    pin,
  } = props;

  const validateInput = (e) => {
    const { value } = e.target;

    if (numberOnly && !/^\d*$/.test(value)) {
        return
    } else if (telOnly && !/^\+$|^\+4$|^\+45\d{0,8}$|^\d{0,8}$/.test(value)) {
        return
    }

    onChange(value);
}

const inputIndicator =
    (error && <span className="input-indicator error">!</span>) ||
    null

const inputClass = classNames(
    'component-textinput__label__input',
    error && 'component-textinput__label__input--error',
    pin && 'component-textinput__label__input--pin',
)

const containerClasses = classNames(
    'component-textinput',
    `component-textinput-${type}`,
    error && 'has-validation-error',
    modifier && `component-textinput--${modifier}`,
    className,
)

const labelClasses = classNames(
    'component-textinput__label__text',
    hideLabel && 'ys-u-visuallyhidden'
)

return (
    <div className={containerClasses}>
        <label className="component-textinput__label">
            {label &&
                <span className={labelClasses}>{label}</span>
            }
            <input
                className={inputClass}
                name={name}
                type={type}
                value={value}
                onChange={validateInput}
                readOnly={readOnly}
                placeholder={placeholder}
                min={min}
                max={max}
                maxLength={maxLength}
                noValidate
                data-hj-suppress
            />
            {
                inputIndicator
            }
            {pin
                && <div className="component-textinput__label__pin-border">
                    <span />
                    <span />
                    <span />
                    <span />
                </div>
            }
            {error &&
                <div className='component-textinput__label__error-text'>{error}</div>
            }
        </label>
    </div>
    );
};

interface ITextInput {
   name: string,
   value: string | number,
   onChange?: () => void;
   label: string,
   hideLabel: boolean,
   modifier: string,
   type: string,
   placeholder: string,
   error: string,
   min: string,
   max: string,
   maxLength: string,
   className: string,
   numberOnly: boolean,
   telOnly: boolean,
   pin: boolean,
   approved: boolean,
   readOnly: boolean,
} 

export default TexITextInput;
